import { ELButton, ELLink } from '@davincihealthcare/elty-design-system-react';

type NoAvailabilitiesInfoProps = {
  title: string;
  description?: string;
  path?: string;
  leadingIcon?: React.ReactNode;
  onClick?: () => void;
};

export const NoAvailabilitiesInfo: React.FC<NoAvailabilitiesInfoProps> = ({ path, title, description, leadingIcon, onClick }) => (
  <div className="flex h-full flex-col items-center justify-center gap-5 text-center">
    <p className="text-base font-normal text-neutral-darker">{title}</p>
    {onClick && description && (
      <div className="w-full md:w-auto">
        <ELButton
          size="small"
          variant="outlined"
          color="primary"
          label={description}
          onClick={onClick}
          leadingIcon={leadingIcon}
          fullRadius
          fullWidth
        />
      </div>
    )}
    {path && description && (
      <ELLink aria-label={description} size="small" variant="outlined" color="primary" label={description} href={path} float />
    )}
  </div>
);
